import { css } from '@/styled-system/css';
import { token } from '@/styled-system/tokens';

// Paired chevron controls in the module title row at lg+; below lg touch swipe is the affordance.
export const petHeaderControls = css({
  display: 'none',
  lg: {
    display: 'flex',
    alignItems: 'center',
    gap: 'tighter',
    // Clearance so the focus outline isn't clipped by the module container's overflow:hidden.
    paddingRight: '100',
  },
});

export const petHeaderControlsHidden = css({
  visibility: 'hidden',
});

export const petControlButton = css({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '900',
  height: '900',
  borderRadius: '50%',
  borderWidth: 'default',
  borderStyle: 'solid',
  borderColor: 'border.subtle',
  backgroundColor: 'bg.neutral',
  cursor: 'pointer',
  color: 'text.neutral',
  transitionProperty: 'background-color, color',
  transitionDuration: '0.15s',
  transitionTimingFunction: 'ease',
  _hover: {
    backgroundColor: 'bg.softest',
  },
  _focusVisible: {
    outlineWidth: 'thick',
    outlineStyle: 'solid',
    outlineColor: 'brand.primary',
    outlineOffset: '50',
  },
  '&[aria-disabled="true"]': {
    opacity: 0.5,
    cursor: 'default',
    _hover: {
      backgroundColor: 'bg.neutral',
    },
  },
});

// Individual card styling for pet policy cards
export const petCardItem = css({
  display: 'flex',
  flexDirection: 'column',
  width: '75%',
  maxWidth: '75%',
  md: {
    width: `calc(50% - ${token.var('spacing.tighter')})`,
    maxWidth: `calc(50% - ${token.var('spacing.tighter')})`,
  },
});

export const petCardItemSingle = css({
  display: 'flex',
  flexDirection: 'column',
  width: '50%',
  maxWidth: '50%',
});

export const petCard = css({
  wordWrap: 'break-word',
  overflowWrap: 'break-word',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',

  flex: 1,
});

// Container for individual pet details within each card
export const petDetails = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'tighter',
  width: '100%',

  minWidth: 0,

  flex: 1,
});

// Styling for pet icons (dog/cat). Color goes through currentColor → stroke;
// no path fill (Lucide icons are outline-only).
export const petIcon = css({
  color: 'brand.primary',
});

// Container for additional information section (restrictions/comments)
export const additionalInfo = css({
  marginTop: 'default',
  paddingTop: 'default',
  borderTopWidth: 'default',
  borderTopStyle: 'solid',
  borderColor: 'border.neutral',
  width: '100%',

  minWidth: 0,
});

// Label styling for additional information sections
export const infoLabel = css({
  fontSize: 'body-sm',
  color: 'text.subtle',
  fontWeight: 'bold',
  marginBottom: 'tightest',
});

// Content styling for additional information
export const infoContent = css({
  fontSize: 'body-sm',
  color: 'text.neutral',
  lineHeight: 'body-sm',
  wordWrap: 'break-word',
  overflowWrap: 'break-word',
  wordBreak: 'break-word',
  hyphens: 'auto',
});

// Spacing between additional info sections
export const additionalInfoSection = css({
  marginTop: 'default',
});

// No data state message styling
export const noDataMessage = css({
  textAlign: 'center',
  color: 'text.subtle',
  fontSize: 'body',
  paddingTop: 'looser',
  paddingBottom: 'looser',
  paddingLeft: 'default',
  paddingRight: 'default',
  fontStyle: 'italic',
});
